const widgetData = (data, mode, currency, isOcm) => {
  const response = [];

  if (mode === 'eyeo') {
    response.push({
          icon: 'fe-eye',
          color: 'primary',
          value: parseInt(data.requests).toLocaleString('de-DE'),
          text: 'Impressions',
          id: 1,
        },
        {
          icon: 'fe-dollar-sign',
          color: 'info',
          value: currency + data.cpm.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'eCPM',
          id: 2,
        },
        {
          icon: 'fe-user',
          color: 'warning',
          value: currency + data.publisherGrossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Publisher Gross',
          id: 3,
        },
        {
          icon: 'fe-user',
          color: 'warning',
          value: currency + data.publisherNetRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Publisher Net',
          id: 4,
        },
        {
          icon: 'fe-trending-up',
          color: 'secondary',
          value: currency + data.grossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Unblockia Gross',
          id: 5,
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: currency + data.netRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Eyeo Net',
          id: 6,
        },
        {
          icon: 'fe-eye',
          color: 'warning',
          value: data.viewRate ? ( (100*data.viewRate.toLocaleString('de-DE', {maximumFractionDigits: 2})).toFixed(2) + '%') : '0%',
          text: 'Viewability',
          id: 7,
        }
    );

    return response
  }

  if (mode === 'admin') {
    response.push(
        {
          icon: 'fe-eye',
          color: 'primary',
          value: data.requests ? data.requests.toLocaleString('de-DE') : 0,
          text: 'Impressions',
          id: 1,
        },
        {
          icon: 'fe-dollar-sign',
          color: 'info',
          value: data.cpm ? currency + data.cpm.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'eCPM',
          id: 2,
        },
        {
          icon: 'fe-trending-up',
          color: 'secondary',
          value: data.grossRevenue ? currency + data.grossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Unblockia Gross',
          id: 3,
          tooltip: 'Value without SSP'
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: data.netRevenue ? currency + data.netRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Unblockia Net',
          id: 4,
          tooltip: '30% Margin + Unblockia\'s Rev Share Net'
        },
        {
          icon: 'fe-trending-up',
          color: 'secondary',
          value: data.eyeoGrossRevenue ? currency + data.eyeoGrossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Unblockia Revshare',
          id: 5,
          tooltip: 'Eyeo Gross Revenue'
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: data.eyeoNetRevenue ? currency + data.eyeoNetRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Eyeo Net',
          id: 6,
          tooltip: '30% of Unblockia\'s Rev Share'
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: data.publisherGrossRevenue ? currency + data.publisherGrossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Publisher gross',
          id: 7,
          tooltip: 'Unblockia Gross - 30% Margin'
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: data.publisherNetRevenue ? currency + data.publisherNetRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'Publisher Net',
          id: 8,
          tooltip: '% of the Rev. Share (80% or 75%)'
        },
    );
  }

  if(mode === 'finance'){
    response.push(
      {
        icon: 'fe-eye',
        color: 'primary',
        value: data.requests ? data.requests.toLocaleString('de-DE') : 0,
        text: 'Impressions',
        id: 1,
      },
      {
        icon: 'fe-dollar-sign',
        color: 'info',
        value: data.cpm ? currency + data.cpm.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
        text: 'eCPM',
        id: 2,
      },
      {
        icon: 'fe-trending-up',
        color: 'secondary',
        value: data.grossRevenue ? currency + data.grossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
        text: 'Unblockia Gross',
        id: 3,
        tooltip: 'Value without SSP'
      },
      {
        icon: 'fe-bar-chart',
        color: 'warning',
        value: data.eyeoNetRevenue ? currency + data.eyeoNetRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
        text: 'Eyeo Net',
        id: 6,
        tooltip: '30% of Unblockia\'s Rev Share'
      },
      {
        icon: 'fe-bar-chart',
        color: 'warning',
        value: data.publisherNetRevenue ? currency + data.publisherNetRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
        text: 'Publisher Net',
        id: 8,
        tooltip: '% of the Rev. Share (80% or 75%)'
      },
  );
  }

  if (['user', 'media buyer', 'account manager', 'trafficker'].includes(mode)) {
    response.push(
        {
          icon: 'fe-eye',
          color: 'primary',
          value: data.requests.toLocaleString('de-DE'),
          text: 'Impressions',
          id: 1,
        },
        {
          icon: 'fe-dollar-sign',
          color: 'info',
          value: data.cpm? currency + data.cpm.toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + '0',
          text: 'eCPM',
          id: 2,
        },
        {
          icon: 'fe-trending-up',
          color: 'secondary',
          value: currency + data.grossRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Gross Revenue',
          id: 3,
        },
        {
          icon: 'fe-bar-chart',
          color: 'warning',
          value: currency + data.netRevenue.toLocaleString('de-DE', {maximumFractionDigits: 2}),
          text: 'Net Revenue',
          id: 4,
        }
    );

    if (isOcm) {
      response.push(
          {
            icon: 'fe-zap',
            color: 'warning',
            value: (data.grossRevenue - data.netRevenue).toLocaleString('de-DE', {maximumFractionDigits: 2}) + currency,
            text: "Unblockia's share",
            id: 4,
          }
      )
    }
  }



  return response;
};

const IMPRESSIONS_COLOR = '#6658DD';
const ECPM_COLOR = '#abdee6';
const REVENUE_COLOR = '#Fcda89';


const YAXIS_COLOR = '#0c4876';

const sspsColors = {
  CRITEO_COLOR: '#ffc5c5',
  RUBICON_COLOR: '#a2e1db',
  APPNEXUS_COLOR:'#e3dfff',
  SMART_COLOR: '#f7e6d9',
  SMART_UNBLOCKIA_COLOR: '#cab5a5',
  ADFORM_COLOR: '#9dc0e1',
  SOVRN_COLOR: '#d2e9c6',
  OUTBRAIN_COLOR: '#33bba7',
  ONETAG_COLOR: '#5d6ac7',
  // MYTARGET_COLOR: '#facba7',
  // BIDSCUBE_COLOR: '#ba6ba7',
  // ADTRUE_COLOR: '#e7dba7',
  GOOGLE_ADX_COLOR: '#8a9ba7',
  PUBLISHER_DEMAND_COLOR: '#e8b5a5',
};

const sspsProviders = ['Criteo', 'Rubicon', 'Appnexus', 'Smart', 'Smart Unblockia', 'Adform', 'Sovrn', 'Outbrain', 'Openx', 'Onetag', 'Pubmatic', 'Google ADX', 'Publisher Demand', 'Between', 'Smilewanted', 'Richaudience'];

const historyChart = (context, data, currency) => ({
  series: [{
    name: 'Impressions',
    type: 'line',
    data: data.map((x) => x.requests)
  }, {
    name: 'eCPM',
      type: 'column',
    data: data.map((x) => x.cpm)
  }, {
    name: 'Net Revenue',
    type: 'column',
    data: data.map((x) => x.netRevenue)
  }],
  chartOptions: {
    dataLabels: {
      enabled: false
    },
    colors:[IMPRESSIONS_COLOR, ECPM_COLOR, REVENUE_COLOR],
    stroke: {
      width: [3, 3, 3],
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      { // 1
        seriesName: 'Impressions',
        decimalsInFloat: 0,
        opposite: false,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: IMPRESSIONS_COLOR
        },
        labels: {
          style: {
            color: IMPRESSIONS_COLOR,
          },
          formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
        },
      },
      {
        seriesName: 'eCPM',
        decimalsInFloat: 2,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: ECPM_COLOR
        },
        labels: {
          style: {
            color: ECPM_COLOR,
          },
          formatter: (value) => { return value ? currency + parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) : currency + 0 },
        },
        title: {
          style: {
            color: ECPM_COLOR,
          }
        }
      },
      {
        seriesName: 'Revenue',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: REVENUE_COLOR
        },
        labels: {
          style: {
            color: REVENUE_COLOR,
          },
          formatter: (value) => { return currency + parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});

const pieChart = (data, colors) => ({
  series: data.rates,
  chartOptions: {
    labels: data.labels,
    colors: colors,
    chart: {
      type: 'donut',
    },
    responsive: [{
      breakpoint: undefined,
      options: {
        chart: {
          width: 200
        }
      }
    }],
    plotOptions: {
      pie: {
        customScale: 1,
        donut: {
          size: '50%'
        },
        expandOnClick: false
      }
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
    },
    tooltip: {
      y: {
        formatter: (value) => { return value ? parseFloat(value).toFixed(1) + '%' : 0 + '%' },
      }
    },

  }
});

const geoChart = (data) => ({
  series: [{
    name: 'Impressions',
    data: data.data
  }],
  chartOptions: {
    chart: {
      type: 'bar',
      height: 350
    },
    colors: ['#a18beb'],
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: data.labels,
      labels: {
        formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
      }
    },
    tooltip: {
      y: {
        formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
      }
    },
  },

})

const sspsChart = (context, data) => ({
  series: [{
    name: 'Rubicon',
    type: 'line',
    data: data.map((x) => x.rubiconRequests)
  }, {
    name: 'eCPM',
    type: 'column',
    data: data.map((x) => x.cpm)
  }, {
    name: 'Criteo',
    type: 'column',
    data: data.map((x) => x.criteoRequests)
  }],
  chartOptions: {
    dataLabels: {
      enabled: false
    },
    colors:[IMPRESSIONS_COLOR, ECPM_COLOR, REVENUE_COLOR],
    stroke: {
      width: [3, 3, 3],
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      { // 1
        seriesName: 'Impressions',
        decimalsInFloat: 0,
        opposite: false,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: IMPRESSIONS_COLOR
        },
        labels: {
          style: {
            color: IMPRESSIONS_COLOR,
          },
          formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
        },
      },
      {
        seriesName: 'eCPM',
        decimalsInFloat: 2,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: ECPM_COLOR
        },
        labels: {
          style: {
            color: ECPM_COLOR,
          },
          formatter: (value) => { return value ? parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' : 0 + '€' },
        },
        title: {
          style: {
            color: ECPM_COLOR,
          }
        }
      },
      {
        seriesName: 'Revenue',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: REVENUE_COLOR
        },
        labels: {
          style: {
            color: REVENUE_COLOR,
          },
          formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});

const revenueRadialChart = {
  series: [60],
  chartOptions: {
    chart: {
      toolbar: {
        show: false,
      },
    },
    stroke: {
      lineCap: 'round',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '65%',
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            formatter: function(val) {
              return parseInt(val)
            },
            fontSize: '24px',
            offsetY: 10,
            color: 'rgb(241, 85, 108)',
          },
        },
      },
    },
    colors: ['rgb(241, 85, 108)'],
  },
};

const userBalanceData = [
  {
    image: require('@assets/images/users/user-2.jpg'),
    name: 'Tomaslau',
    icon: 'mdi mdi-currency-btc',
    currency: 'BTC',
    balance: '0.00816117 BTC',
    order: '0.00097036 BTC',
  },
  {
    image: require('@assets/images/users/user-3.jpg'),
    name: 'Erwin E. Brown',
    icon: 'mdi mdi-currency-eth',
    currency: 'ETH',
    balance: '3.16117008 ETH',
    order: '1.70360009 ETH',
  },
  {
    image: require('@assets/images/users/user-4.jpg'),
    name: 'Margeret V. Ligon',
    icon: 'mdi mdi-currency-eur',
    currency: 'EUR',
    balance: '25.08 EUR',
    order: '12.58 EUR',
  },
  {
    image: require('@assets/images/users/user-5.jpg'),
    name: 'Jose D. Delacruz',
    icon: 'mdi mdi-currency-cny',
    currency: 'CNY',
    balance: '82.00 CNY',
    order: '30.83 CNY',
  },
  {
    image: require('@assets/images/users/user-6.jpg'),
    name: 'Luke J. Sain',
    icon: 'mdi mdi-currency-btc',
    currency: 'BTC',
    balance: '2.00816117 BTC',
    order: '1.00097036 BTC',
  },
];

const sspsImpressionChart = (data, providers, max) => ({
  series: [
    ...providers.map(provider => ({
      name: provider,
      type: 'column',
      data: data.map(x => {
        let stats = x.providerStats.filter( y => y.name === provider)
        return stats.length > 0 ? stats[0].impressions : 0;
      })
    })),
    {
      name: 'Total',
      type: 'line',
      data: data.map(x => x.providerStats.reduce((a, b) => a + b.impressions, 0))
    }
  ],
  chartOptions: {
    grid: {
      padding: {
        left: 50,
        right: 50
      }
    },
    chart: {
      toolbar: {
        autoSelected: 'pan',
      },
    },
    dataLabels: {
      enabled: false
    },
    colors:[ ...Object.values(sspsColors), IMPRESSIONS_COLOR],
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      ...providers.map((provider, index) => {
        if(index == 1) {
          return {
            seriesName: 'Impressions',
            decimalsInFloat: 0,
            opposite: false,
            max: max,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: true,
              color: YAXIS_COLOR
            },
            labels: {
              style: {
                color: YAXIS_COLOR
              },
              formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
            },
          }
        }
        return {
          seriesName: 'Impressions',
          decimalsInFloat: 0,
          max: max,
          show: false,
          labels: {
            style: {
              color: YAXIS_COLOR
            },
            formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
          },
        }

      }),
      {
        seriesName: 'Total',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: IMPRESSIONS_COLOR
        },
        labels: {
          style: {
            color: IMPRESSIONS_COLOR,
          },
          formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
        },
      }
    ]
    ,
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});

const sspsRevenueChart = (data, providers, max) => ({
  series: [
    ...providers.map(provider => ({
      name: provider,
      type: 'column',
      data: data.map(x => {
        let stats = x.providerStats.filter( y => y.name === provider)
        return stats.length > 0 ? stats[0].revenue : 0;
      })
    })),
    {
      name: 'Total',
      type: 'line',
      data: data.map(x => x.providerStats.reduce((a, b) => a + b.revenue, 0))
    }
  ],
  chartOptions: {
    grid: {
      padding: {
        left: 50,
        right: 50
      }
    },
    chart: {
      toolbar: {
        autoSelected: 'pan',
      },
    },
    dataLabels: {
      enabled: false
    },
    colors:[ ...Object.values(sspsColors), REVENUE_COLOR],
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      ...providers.map((provider, index) => {
        if(index == 1) {
          return {
            seriesName: 'Revenue',
            decimalsInFloat: 0,
            max: max,
            opposite: false,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: true,
              color: YAXIS_COLOR
            },
            labels: {
              style: {
                color: YAXIS_COLOR
              },
              formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
            },
          }
        }
        return {
          seriesName: 'Revenue',
          decimalsInFloat: 0,
          max: max,
          show: false,
          labels: {
            formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
          },
        }
      }),
      {
        seriesName: 'Total',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: REVENUE_COLOR
        },
        labels: {
          style: {
            color: REVENUE_COLOR,
          },
          formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
        },
      }
    ]
    ,
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});

const sspsCpmChart = (data, providers, max) => ({
  series: [
    ...providers.map(provider => ({
      name: provider,
      type: 'column',
      data: data.map(x => {
        let stats = x.providerStats.filter( y => y.name === provider)
        return stats.length > 0 ? stats[0].cpm : 0;
      })
    })),
    {
      name: 'Average',
      type: 'line',
      data: data.map(x => {
        const cpmSum = x.providerStats.reduce((a, b) => a + b.cpm, 0);
        const providerNum = x.providerStats.length;
        return cpmSum / providerNum
      })
    }
  ],
  chartOptions: {
    grid: {
      padding: {
        left: 50,
        right: 50
      }
    },
    chart: {
      toolbar: {
        autoSelected: 'pan',
      },
    },
    dataLabels: {
      enabled: false
    },
    colors:[ ...Object.values(sspsColors), ECPM_COLOR],
    stroke: {
      width: 2,
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis:[
      ...providers.map((provider, index) => {
        if(index == 1) {
          return {
            seriesName: 'eCPM',
            decimalsInFloat: 2,
            opposite: false,
            max: max,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: true,
              color: YAXIS_COLOR
            },
            labels: {
              style: {
                color: YAXIS_COLOR,
              },
              formatter: (value) => { return value ? parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' : 0 + '€' },
            }
          }
        }
        return {
          seriesName: 'eCPM',
          decimalsInFloat: 2,
          max: max,
          show: false,
          labels: {
            formatter: (value) => { return value ? parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' : 0 + '€' },
          },
        }
      }),
      {
        seriesName: 'Average',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: ECPM_COLOR
        },
        labels: {
          style: {
            color: ECPM_COLOR,
          },
          formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
        },
      }
    ]
    ,
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});

const sspsHistoryChart = (provider, data) => ({
  series: [{
    name: 'Impressions',
    type: 'line',
    data: data.map((x) => x.providerStats.filter( y => y.name === provider)[0].impressions)
  }, {
    name: 'eCPM',
      type: 'column',
    data: data.map((x) => x.providerStats.filter( y => y.name === provider)[0].cpm)
  }, {
    name: 'Revenue',
    type: 'column',
    data: data.map((x) => x.providerStats.filter( y => y.name === provider)[0].revenue)
  }],
  chartOptions: {
    grid: {
      padding: {
        left: 50,
        right: 50
      }
    },
    chart: {
      toolbar: {
        autoSelected: 'pan',
      },
      width: '100%'
    },
    dataLabels: {
      enabled: false
    },
    colors:[IMPRESSIONS_COLOR, ECPM_COLOR, REVENUE_COLOR],
    stroke: {
      width: [3, 3, 3],
      curve: 'smooth'
    },
    title: {
      align: 'left',
      offsetX: 110
    },
    xaxis: {
      categories: data.map(x => x.date),
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      { // 1
        seriesName: 'Impressions',
        decimalsInFloat: 0,
        opposite: false,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: IMPRESSIONS_COLOR
        },
        labels: {
          style: {
            color: IMPRESSIONS_COLOR,
          },
          formatter: (value) => { return parseInt(value).toLocaleString('de-DE') },
        },
      },
      {
        seriesName: 'eCPM',
        decimalsInFloat: 2,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: ECPM_COLOR
        },
        labels: {
          style: {
            color: ECPM_COLOR,
          },
          formatter: (value) => { return value ? parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' : 0 + '€' },
        },
        title: {
          style: {
            color: ECPM_COLOR,
          }
        }
      },
      {
        seriesName: 'Revenue',
        decimalsInFloat: 0,
        opposite: true,
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: true,
          color: REVENUE_COLOR
        },
        labels: {
          style: {
            color: REVENUE_COLOR,
          },
          formatter: (value) => { return parseFloat(value).toLocaleString('de-DE', {maximumFractionDigits: 2}) + '€' },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60
      },
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 40,
      offsetY: -0
    }
  },
});


export { sspsColors, sspsProviders, widgetData, revenueRadialChart, historyChart, userBalanceData, sspsImpressionChart, sspsRevenueChart, sspsCpmChart, sspsHistoryChart,  sspsChart, pieChart, geoChart}
